export type MarkdownCommand = 'heading' | 'bold' | 'italic' | 'quote' | 'unordered-list' | 'ordered-list' | 'link'
export type MarkdownEdit = { value: string, selectionStart: number, selectionEnd: number }

const placeholder = (command: MarkdownCommand): string => ({ heading: 'Heading', bold: 'text', italic: 'text', quote: 'Quote', 'unordered-list': 'List item', 'ordered-list': 'List item', link: 'link text' })[command]
const lineRange = (value: string, start: number, end: number): { start: number, end: number, text: string } => {
    const rangeStart = value.lastIndexOf('\n', Math.max(0, start - 1)) + 1
    const nextLine = value.indexOf('\n', end)
    const rangeEnd = nextLine === -1 ? value.length : nextLine
    return { start: rangeStart, end: rangeEnd, text: value.slice(rangeStart, rangeEnd) }
}

export function applyMarkdownCommand (value: string, start: number, end: number, command: MarkdownCommand): MarkdownEdit {
    const selection = value.slice(start, end) || placeholder(command)
    if (command === 'bold' || command === 'italic' || command === 'link') {
        const prefix = command === 'bold' ? '**' : command === 'italic' ? '_' : '['
        const suffix = command === 'bold' ? '**' : command === 'italic' ? '_' : '](https://example.com)'
        const inserted = `${prefix}${selection}${suffix}`
        return { value: `${value.slice(0, start)}${inserted}${value.slice(end)}`, selectionStart: start + prefix.length, selectionEnd: start + prefix.length + selection.length }
    }
    const range = lineRange(value, start, end)
    const lines = (range.text || placeholder(command)).split('\n')
    const transformed = command === 'heading'
        ? lines.map((line) => `## ${line || placeholder(command)}`).join('\n')
        : command === 'quote'
            ? lines.map((line) => `> ${line || placeholder(command)}`).join('\n')
            : command === 'unordered-list'
                ? lines.map((line) => `- ${line || placeholder(command)}`).join('\n')
                : lines.map((line, index) => `${index + 1}. ${line || placeholder(command)}`).join('\n')
    return { value: `${value.slice(0, range.start)}${transformed}${value.slice(range.end)}`, selectionStart: range.start, selectionEnd: range.start + transformed.length }
}
